import { render, staticRenderFns } from "./ModalEditTermText.vue?vue&type=template&id=6e66956c"
import script from "./ModalEditTermText.vue?vue&type=script&lang=js"
export * from "./ModalEditTermText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports